<template>
    <div class="home-view">
        <Topbar />
        <br>
        <div class="container-img mt-2">
            <div class="col-md-6 m-auto">
                <br>
                <div class="card" v-if="!this.enderecoDestino">
                    <div class="card-header small text-white p-0" :style="{ backgroundColor: moduloAtual().color }">
                        ENTRADA MANUAL
                        <div v-show="carregando" class="spinner-grow">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div class="card-body p-1 small text-left">
                        <select class="form-control form-control-sm" id="cliente">
                            <option value="">
                                -- Selecione o Cliente --
                            </option>
                            <option v-for="option in clientes" :value="option.id" :key="option.id">
                                {{ option.fantasia }} - {{ option.id }}
                            </option>
                            
                        </select>

                        <div class="mt-2 small">
                            <InputDefaultApp
                                key="enderecoInput"
                                inputPlaceHolderSufixo="Digite o endereço destino"
                                titleScan="Escanear Endereço"
                                typeInputMode="text"
                                @displayScanFunction="buscarEndereco"
                                :enterKey="(e) => buscarEndereco(e.target.value)"
                                idInput="enderecoInput"
                                :errorMessage="this.enderecoDestinoErrorMessage"
                                :toUpperCase="true"
                            />
                        </div>          
                    </div>
                </div>

                <div class="card" v-if="this.enderecoDestino">
                    <div class="card-header small text-white p-0" :style="{ backgroundColor: moduloAtual().color }">
                        ENTRADA MANUAL
                        <div v-show="carregando" class="spinner-grow">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div class="card-body p-1 small text-left">

                        <div class="mt-0 small">

                            <div class="border w-100 text-left rounded p-1 mb-2">
                                <span class="font-weight-bold">Cliente:</span>:
                                <span class="text-danger">
                                    {{ this.clienteFantasia }}
                                </span>
                                <br>
                                <span class="font-weight-bold">Endereço:</span>:
                                <span class="text-danger">
                                    {{ this.enderecoDestino.descricao }}
                                </span>
                                <br>
                                <span class="font-weight-bold">End. Quarentena:</span>:
                                <span>
                                    [{{ this.enderecoDestino.quarentena }}]
                                </span>
                                <br>
                                <span class="font-weight-bold">End. Pulmão:</span>:
                                <span>
                                    [{{ this.enderecoDestino.pulmao }}]
                                </span>
                                <br>
                            </div> 

                            <InputDefaultApp
                                key="produtoInput"
                                idInput="produtoInput"
                                inputPlaceHolderSufixo="Digite o produto"
                                titleScan="Escanear Produto"
                                typeInputMode="text"
                                @displayScanFunction="buscarProduto"
                                :enterKey="(e) => buscarProduto(e.target.value)"
                                :errorMessage="this.produtoErrorMessage"
                                :toUpperCase="true"
                            />
                        </div>
                    </div>
                </div>

                <div class="card mt-1" v-if="this.produtoBipado">
                    <div class="card-header small text-white p-0 bg-secondary">
                        PRODUTO
                    </div>
                    <div class="card-body small text-left pl-2 pr-2 pt-0 pb-0">
                        <span class="font-weight-bold small text-danger">{{ this.produtoBipado.descricao }}</span>
                        <div class="border-bottom w-100"></div>
                        <span class="font-weight-bold">Produto</span>:
                        [<span class="text-danger">
                            {{ this.produtoBipado.codbarras }}
                        </span>]
                        <br>
                        <span class="font-weight-bold">Possui Validade</span>:
                        [{{ this.possuiValidade }}]
                        <br>
                        <span class="font-weight-bold">Lote / Validade</span>:
                        <span v-if="this.produtoBipado.lote">
                            [{{ this.produtoBipado.lote }}] - [{{ dateFormat(this.produtoBipado.validade) }}]
                        </span>
                        <span v-if="!this.produtoBipado.lote">
                            NÃO TEM
                        </span>
                        
                        <div class="border w-100 text-center small rounded pt-1 pb-1 mt-2 mb-2">
                            <Interruptor
                                idInput="validade"
                                actionName="Data Validade">
                            </Interruptor> 
                        </div> 
                    </div>
                </div>

                <button class="btn btn-success btn-sm w-100 mt-1" v-if="this.produtoBipado" @click="showModal">
                    Adicionar entrada manual
                    <em class="fa fa-arrow-right ml-2"></em>
                </button>
                <button class="btn btn-danger btn-sm w-100 mt-1" @click="reiniciar" v-if="this.enderecoDestino">
                    Trocar cliente ou endereço
                    <em class="fa fa-undo ml-2"></em>
                </button>

                <div class="mt-5 text-center text-secondary" v-if="!this.enderecoDestino">
                    <em class="fa fa-info-circle fa-3x mb-2"></em>
                    <br>
                    <span class="small">Informe o endereco de destino!</span>
                </div>
            </div>
        </div>

        <Modal
            id="modal1"
            title="Incluir Entrada Manual"
            confirmText="Confirmar"
            cancelText="Cancelar"
            :confirmFunction="entradaManual"
        >
            <div class="alert alert-warning p-1" v-if="this.errorModal">
                {{ this.errorModal }}
            </div>
           <div class="text-left">
                <label for="lote">LOTE</label>
                <input type="text"
                class="form-control form-control-sm"
                autocomplete="off"
                id="lote">

                <label for="validadeModal">DATA VALIDADE</label>
                <CustomDateInput v-model="dateValueModal" idInput="validadeModal" />

                <label for="quantidade">* QUANTIDADE</label>
                <input type="number"
                class="form-control form-control-sm"
                autocomplete="off"
                min="0"
                onkeypress="return event.charCode >= 48"
                id="quantidade">

                <label for="motivo">* MOTIVO</label>
                <input type="text"
                class="form-control form-control-sm"
                autocomplete="off"
                id="motivo">
           </div>
        </Modal>

        <Modal
            id="modalRetorno"
            title="Sucesso"
            :carregando="carregando"
            :buttonList="[]"
            :cancelFunction="() => closeModal('modalRetorno')"
            cancelText="OK"
        >
            <div class="small text-center">
                <em class="fa fa-check-circle text-success fa-3x"></em>
                <br>
                <br>
                <span>{{ this.retornoMessage }}</span>
            </div>
        </Modal>

        <LogoutModal />
        <FooterBar v-if="!this.produtoBipado" />
    </div>
</template>
  
<script>
    // @ is an alias to /src
    import Topbar from '@/components/Topbar.vue'
    import FooterBar from '@/components/FooterBar.vue'
    import LogoutModal from '@/components/LogoutModal.vue'
    import InputDefaultApp from '../components/InputDefaultApp.vue'
    import Interruptor from '@/components/Interruptor.vue'
    import ViewMixin from './ViewMixin'
    import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
    import api, { getUsername, getPerfil, getUserId } from '../services/api'
    import $ from "jquery"
    import Modal from "../components/Modal.vue"
    import CustomDateInput from '../components/CustomDateInput.vue'
    import audioService from '@/services/audioService.js';
    import { dateFormat } from '../utils';

    export default {
        name: 'Categoria',
        mixins: [
            ViewMixin
        ],
        components: {
            Topbar,
            LogoutModal,
            FooterBar,
            InputDefaultApp,
            Interruptor,
            Modal,
            CustomDateInput
        },
    
        data: () => {
            return {
                menus : [],
                categoriaId: null,
                clientes: [],
                enderecoDestinoErrorMessage: null,
                enderecoDestino: null,
                produtoErrorMessage: null,
                produtoBipado: null,
                possuiValidade: "N",
                clienteReferencia: null,
                clienteFantasia: null,
                dateValueModal: null,
                errorModal: null,
                retornoMessage: null,
            };
        },
    
        async mounted() {
            try {
                await this.validarToken();
                await this.listarClientes();

                document.getElementById('cliente').addEventListener('change', function() {
                    $("#enderecoInput").focus();
                    $("#enderecoInput").select();
                });
            } catch (e) {
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }      
            }
        },
    
        methods: {
            getUsername,
            getPerfil,
            dateFormat,

            closeModal(modal) {
                $("#" + modal).modal("hide");
            },

            showMessageSuccess(message) {
                this.retornoMessage = message;
                $("#modalRetorno").modal('show');
            },

            playSoundSuccess() {
                audioService.success();
            },

            playSoundAlert() {
                audioService.ops();
            },

            async validarToken() {
                this.carregando = true;
        
                await api.get("/validar-token");
        
                this.carregando = false;
            },

            reiniciar() {
                this.enderecoDestino = null;
                this.produtoBipado = null;

                setTimeout(() => {
                    $("#enderecoInput").val("");
                    $("#produtoInput").val("");
                    $("#produtoInput").focus();
                    $("#validade").prop("checked", false);

                    document.getElementById('cliente').addEventListener('change', function() {
                        $("#enderecoInput").focus();
                        $("#enderecoInput").select();
                        $("#validade").prop("checked", false);
                    });
                }, 250);
            },

            async listarClientes() {
                this.carregando = true;
                this.clientes = [];
                
                try {
                    let response = await api.get(`/cliente/listar`);
                    response.data.forEach((e) => {
                        this.clientes.push(e)
                    }, this);

                    setTimeout(() => {
                        $("#enderecoInput").focus();
                    }, 500);
                } catch (e) {
                    console.error(e);
                    this.playSoundAlert();
                }
                this.carregando = false;
            },

            async buscarEndereco(endereco) {

                this.carregando = true;

                try {

                    if ($("#cliente").val() === "") {
                        this.enderecoDestinoErrorMessage = "Informe o cliente!";
                        this.playSoundAlert();
                        this.carregando = false;

                        setTimeout(() => {
                            $("#enderecoInput").focus();
                            $("#enderecoInput").select();
                        }, 250);

                        return;
                    }

                    let response = await api.get("/movimentacao/endereco/"+btoa(endereco));
                    
                    if (JSON.stringify(response.data).includes("descricao"))
                    {   
                        if (response.data.descricao === endereco) {
                           
                            let sel = document.getElementById('cliente');
                            this.clienteFantasia = sel.options[sel.selectedIndex].text;
                            this.clienteReferencia = $("#cliente").val();

                            $("#enderecoInput").val("");

                            this.enderecoDestinoErrorMessage = "";
                            this.enderecoDestino = response.data;

                            setTimeout(() => {
                                $("#produtoInput").val("");
                                $("#produtoInput").focus();
                            }, 250);  
                        }
                    } else {
                        this.enderecoDestinoErrorMessage = "Endereço não encontrado!";
                        this.enderecoDestino = null;
                        $("#enderecoInput").focus();
                        $("#enderecoInput").select();
                        this.playSoundAlert();
                    }
                } catch (e) {
                    this.enderecoDestinoErrorMessage = "Endereço não encontrado!";
                    this.enderecoDestino = null;
                    $("#enderecoInput").focus();
                    $("#enderecoInput").select();
                    this.playSoundAlert();
                }

                this.carregando = false;
            },

            async buscarProduto(codigoBarras) {
                this.carregando = true;
                let body = {
                    "idCliente": this.clienteReferencia,
                    "codigoBarras": codigoBarras
                };

                try {
                    let response = await api.post("/inbound/produto/entradamanual", body);

                    if (JSON.stringify(response.data).includes("idprodutos"))
                    {   
                        this.produtoBipado = response.data.produto;
                        this.produtoErrorMessage = null;

                        setTimeout(() => {
                            document.getElementById('validade').checked = this.produtoBipado.possuivalidade === "S";
                            this.possuiValidade = document.getElementById('validade').checked ? "S" : "N";

                            document.getElementById('validade').addEventListener('change', function() {
                                $("#produtoInput").focus();
                                $("#produtoInput").select();
                            });
                        }, 250);
                        
                        $("#produtoInput").focus();
                        $("#produtoInput").select();
                    }
                } catch (error) {
                    this.produtoErrorMessage = error.message;
                    this.playSoundAlert();
                    $("#produtoInput").focus();
                    $("#produtoInput").select();
                }

                this.carregando = false;
            },

            showModal() {
                $("#modal1").modal("show");
                setTimeout(() => {
                    $("#lote").focus();
                    $("#lote").select();
                }, 500);
            },

            async entradaManual() {

                this.carregando = true;
                this.possuiValidade = document.getElementById('validade').checked ? "S" : "N";

                let lote = $("#lote").val();
                let validade = this.dateValueModal;
                let quantidade = $("#quantidade").val();
                let motivo = $("#motivo").val();

                if (lote.trim() !== "" && validade.trim() === "") {
                    this.errorModal =  "Informe o lote e validade do produto!";
                    this.playSoundAlert();
                    this.carregando = false;
                    return;
                }

                if ((lote === "" || validade === "") && this.possuiValidade === 'S') {
                    this.errorModal =  "Informe o lote e validade do produto!";
                    this.playSoundAlert();
                    this.carregando = false;
                    return;
                }

                if (quantidade.trim() === "") {
                    this.errorModal =  "Informe a quantidade do produto!";
                    this.playSoundAlert();
                    $("#quantidade").focus();
                    this.carregando = false;
                    return;
                }

                if (motivo.trim() === "") {
                    this.errorModal =  "Informe o motivo do produto!";
                    this.playSoundAlert();
                    $("#motivo").focus();
                    this.carregando = false;
                    return;
                }

                try {

                    let body = {
                        "idCliente": this.clienteReferencia,
                        "idProduto": this.produtoBipado.idprodutos,
                        "idUsuario": getUserId(),
                        "endereco": this.enderecoDestino.descricao,
                        "quantidade": quantidade,
                        "motivo": motivo,
                        "lote": lote === "" ? null : lote,
                        "validade": validade === "" ? null : validade,
                        "possuivalidade": this.possuiValidade
                    };

                    let response = await api.post("/inbound/entradamanual", body);
                    $("#modal1").modal("hide");

                    if (response.data.saldo){
                        this.playSoundSuccess();

                        this.showMessageSuccess("Entrada efetuada com sucesso!");
                        
                        setTimeout(() => {
                            this.produtoBipado = null;
                            $("#lote").val("");
                            this.dateValueModal = "";
                            $("#quantidade").val("");
                            $("#motivo").val("");
                            
                            $("#produtoInput").focus();
                            $("#produtoInput").select();

                            this.errorModal = null;
                        }, 1000);
                    }
                } catch (error) { 
                    this.errorModal = error.message;
                    this.playSoundAlert();
                }

                this.carregando = false;
            },
        }
    }
</script>
  
<style scoped lang="scss">    
  
    .home-view {
        height: 100%;
    }
  
    .container-img {
        height: auto;
        display: flex;
        justify-content: center;
        align-self: center;
    }
</style>
  